"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const String = ({
  value,
  format,
  fetched,
  fetching
}) => {
  if (!fetched) return /*#__PURE__*/_react.default.createElement("span", {
    className: 'component-string-placeholder' + (fetching ? ' fetching' : '')
  });
  let string = value;
  if (format) {
    try {
      string = format(value);
    } catch (e) {
      console.dir(e);
    }
  }
  if (!string) return /*#__PURE__*/_react.default.createElement("span", {
    className: 'component-string-placeholder' + (fetching ? ' fetching' : '')
  });
  return /*#__PURE__*/_react.default.createElement("span", null, string);
};
var _default = exports.default = String;
module.exports = exports.default;